import { authGuard } from '@auth0/auth0-vue';
import { createRouter, createWebHistory } from 'vue-router';

import ReadingView from '@/views/ReadingView.vue';
import LoginBox from '@/components/LoginBox.vue';
import SelectAccount from '@/components/SubmitAccount.vue';
import SubmitReading from '@/components/SubmitReading.vue';
import SubmitPhoto from '@/components/SubmitPhoto.vue';
import SubmitConfirmation from '@/components/SubmitConfirmation.vue';
import ReadingsQueue from '@/components/ReadingsQueue.vue';
import ReadingsQueueItem from '@/components/ReadingsItem.vue';
import SwitchCompanyView from '@/views/SwitchCompanyView.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginBox
    },
    {
      path: '/',
      name: '',
      redirect: { name: 'select' },
      component: ReadingView,
      children: [
        {
          path: 'select',
          name: 'select',
          beforeEnter: authGuard,
          component: SelectAccount
        },
        {
          path: 'reading',
          name: 'reading',
          beforeEnter: authGuard,
          component: SubmitReading
        },
        {
          path: 'photo',
          name: 'photo',
          beforeEnter: authGuard,
          component: SubmitPhoto
        },
        {
          path: 'confirmation',
          name: 'confirmation',
          beforeEnter: authGuard,
          component: SubmitConfirmation
        },
        {
          path: 'queue',
          name: 'queue',
          beforeEnter: authGuard,
          component: ReadingsQueue
        },
        {
          path: 'queue/:id',
          name: 'queue-item',
          beforeEnter: authGuard,
          component: ReadingsQueueItem
        },
        {
          path: 'switch-company',
          name: 'switch-company',
          beforeEnter: authGuard,
          component: SwitchCompanyView
        }
      ]
    }
  ]
});

export default router;
